export default {
	section_banner: {
		title: {
			one: 'Global',
		},
		main_title: 'Payment',
		sub_title: 'Processing',
		paragraph: {
			one: 'Receive JPWorldPay and withdraw to the country of your choice. With global accessibility, JPWorldPay allows you to accept payments from anywhere.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	question_sec: {
		label: 'Automatically Applied',
		title: {
			one: 'To Current',
			two: 'Exchange ',
			three: 'Rate',
		},
		paragraph:
			'Withdraw money whenever you want. JPWorldPay gives you full control over your funds, allowing you to access and withdraw your money at any time without restrictions. Whether for business needs or personal use, enjoy the flexibility and freedom to manage your finances on your terms.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	global_mid: {
		label: 'JPWorldPay Custome',
		title: {
			one: 'Make',
			two: 'Payments',
			three: 'Regardless Of Their Country',
		},
		paragraph:
			'JPWorldPay customers can make payments regardless of their country. With global accessibility, users can send and receive funds seamlessly across borders without worrying about regional limitations. This makes JPWorldPay a truly international solution for businesses and individuals looking for fast, secure, and borderless financial transactions.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	online_mid: {
		label: 'No Hidden Fees',
		title: {
			one: 'Why Use',
			two: 'Cryptocurrency',
		},
		paragraph:
			'The best reason is that you only need to look at the number of exchange rates. JPWorldPay simplifies the entire currency conversion process by clearly displaying the applicable rate, so you always know exactly what to expect. No hidden fees, no confusing calculations just straightforward transparency that helps you make smarter financial decisions with ease.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
